import { config } from "../config";
import { authHeader } from "../helpers";
import axios from "axios";

export const productService = {
  getAll,
  getById,
  create,
  update,
  remove,
  getDestinctProductsbyServiceProvider,
  getProductMappings,
  updateProductMapping,
};

function getAll() {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .get(`${config.product_server}/`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function getDestinctProductsbyServiceProvider(serviceProvider) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .get(
      `${config.product_server}/serviceprovider/${serviceProvider}`,
      requestOptions
    )
    .then((responce) => {
      return responce.data;
    });
}

function getById(id) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .get(`${config.product_server}/${id}`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function create(data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .post(`${config.product_server}/`, data, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function update(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .put(`${config.product_server}/${id}`, data, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function remove(id) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .delete(`${config.product_server}/${id}`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function getProductMappings(serviceProvider) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .get(`${config.product_server}/mapping/${serviceProvider}`, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}

function updateProductMapping(data) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };

  return axios
    .post(`${config.product_server}/mapping`, data, requestOptions)
    .then((responce) => {
      return responce.data;
    });
}
